module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_50000.c0a6de7b.png";